// BranchManagement.jsx
import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

const BranchManagement = () => {
  const [branches, setBranches] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [newBranch, setNewBranch] = useState({ name: '', description: '' });
  const [editingBranch, setEditingBranch] = useState(null);

  const fetchWithAuth = async (url, options = {}) => {
    
    const session = await supabase.auth.getSession();
    const token = session.data?.session?.access_token;

    const headers = {
      ...options.headers,
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    };

    return fetch(url, { ...options, headers });
  };

  useEffect(() => {
    fetchBranches();
  }, []);

  const fetchBranches = async () => {
    const res = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/branches`);
    const data = await res.json();
    setBranches(data.branches);
  };

  const handleCreate = async () => {
    const method = editingBranch ? 'PUT' : 'POST';
    const url = editingBranch
      ? `${process.env.REACT_APP_API_URL}/api/branches/${editingBranch.id}`
      : `${process.env.REACT_APP_API_URL}/api/branches`;

    await fetchWithAuth(url, {
      method,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newBranch),
    });

    setNewBranch({ name: '', description: '' });
    setEditingBranch(null);
    setShowModal(false);
    fetchBranches();
  };

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h2>Branch Management</h2>
      <button onClick={() => { setShowModal(true); setEditingBranch(null); setNewBranch({ name: '', description: '' }); }} style={{ marginBottom: '20px' }}>Add Branch</button>

      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th style={{ borderBottom: '1px solid #ccc', textAlign: 'left', padding: '8px' }}>Name</th>
            <th style={{ borderBottom: '1px solid #ccc', textAlign: 'left', padding: '8px' }}>Description</th>
            <th style={{ borderBottom: '1px solid #ccc', textAlign: 'left', padding: '8px' }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {branches.map(b => (
            <tr key={b.id}>
              <td style={{ borderBottom: '1px solid #eee', padding: '8px' }}>{b.name}</td>
              <td style={{ borderBottom: '1px solid #eee', padding: '8px' }}>{b.description}</td>
              <td style={{ borderBottom: '1px solid #eee', padding: '8px' }}>
                <button onClick={() => {
                  setNewBranch({ name: b.name, description: b.description });
                  setEditingBranch(b);
                  setShowModal(true);
                }}>Edit</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {showModal && (
        <div style={{
          marginTop: '30px',
          padding: '20px',
          border: '1px solid #ccc',
          borderRadius: '8px',
          background: '#f9f9f9'
        }}>
          <h3>{editingBranch ? 'Edit Branch' : 'Add New Branch'}</h3>
          <div style={{ marginBottom: '10px' }}>
            <label>Name:</label><br />
            <input
              style={{ width: '100%', padding: '8px' }}
              value={newBranch.name}
              onChange={e => setNewBranch({ ...newBranch, name: e.target.value })}
            />
          </div>
          <div style={{ marginBottom: '10px' }}>
            <label>Description:</label><br />
            <input
              style={{ width: '100%', padding: '8px' }}
              value={newBranch.description}
              onChange={e => setNewBranch({ ...newBranch, description: e.target.value })}
            />
          </div>
          <button onClick={handleCreate} style={{ marginRight: '10px' }}>
            {editingBranch ? 'Update' : 'Create'}
          </button>
          <button onClick={() => { setShowModal(false); setEditingBranch(null); }}>Cancel</button>
        </div>
      )}
    </div>
  );
};

export default BranchManagement;